import request from '../../util/SuperagentUtils';

/** Service charge payload sent when creating a service charge or calculating its tax */
export interface ServiceFeeChargeRequest {
  serviceFeeType: string;
  /** Charge amount in cents */
  chargeAmount: number;
  notes?: string;
  /** Only sent by the legacy (non tax-collecting) service fee form */
  taxRate?: number;
}

export const requestCreateServiceCharge = (bookingId: string, serviceFeeCharge: ServiceFeeChargeRequest) => {
  return request.post(`/api/booking/${bookingId}/service-charge`)
    .send(serviceFeeCharge);
}

export const requestCalculateServiceChargeTax = (bookingId: string, serviceFeeCharge: ServiceFeeChargeRequest) => {
  return request.post(`/api/booking/${bookingId}/service-charge/calculate-tax`)
    .send(serviceFeeCharge);
}

export const requestBookingTransactionById = (bookingTransactionId: string) => {
  return request.get(`/api/booking-transaction/${bookingTransactionId}`);
}
